import "./ClinicalLeadership.module.css";
import Header from "@/reusable_sections/Header";
import ExcellenceInPsychiatry from "./sections/ExcellenceInPsychiatry";
import TheCareTeam from "./sections/TheCareTeam";
import Footer from "@/reusable_sections/Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export default function ClinicalLeadershipPage() {
  const {
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({
            behavior: "smooth"
          });
        }, 300); // small delay lets the page render first
      }
    }
  }, [hash]);
  return <div>
      <Header />
      <ExcellenceInPsychiatry />
      <TheCareTeam />
      <Footer />
    </div>;
}